'use client'
import cssStyles from "./language-selector.module.css"
import React, {CSSProperties} from "react";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {useParams} from "next/navigation";
import {DictionaryLocale} from "@web-libs/core/internationalization/dictionary.types";
import {Color, getCssVar} from "@web-libs/features/colors/application/colors";
import Select, {StylesConfig} from "react-select";
import dynamic from "next/dynamic";


type LanguageSelectorProps = {
    containerStyle? : CSSProperties,
   style?: CSSProperties,
    background?: Color
}

type LanguageOption = {
    value: string,
    label: string,
    input: string
}
export const _LanguageSelector = (props : LanguageSelectorProps) => {
    const _style: CSSProperties ={
        background: props.background ? getCssVar(props.background): undefined,
        width: "100px",
        ...props.style
    }
    const languageStyles: StylesConfig = {
        control: (styles) => ({ ...styles, ..._style }),
        option: (styles,{isSelected} ) => ({ ...styles, ..._style, color: isSelected ? getCssVar("primary") :_style.color }),
        menu: (styles) => ({ ...styles, ..._style }),
    }
    const router = useTageaRouter();
    const params = useParams()
    const options: LanguageOption[] = [
        { value: 'de', label: 'deutsch', input: 'de' },
        { value: 'en', label: 'english', input: 'en' },
        { value: 'fr', label: 'français', input: 'fr' },
        { value: 'es', label: 'español', input: 'es' },
        { value: 'pl', label: 'polski', input: 'pl' },
        { value: 'ru', label: 'rусский', input: 'ru' },
        { value: 'tr', label: 'türkçe', input: 'tr' },
        { value: 'uk', label: 'українська', input: 'uk' },
        { value: 'ro', label: 'română', input: 'ro' },
        { value: 'it', label: 'italiano', input: 'it' },
        { value: 'ar', label: 'العربية', input: 'ar' },
    ]
    const defaultValueIndex = options.findIndex((value)=> { return value.value == params.lang})
    const changeLanguage = (option: string) => {
        router.changeLanguage(option as DictionaryLocale)
    }

    return ( <div className={cssStyles.dropdownContainer} style={props.containerStyle}>
        <Select styles={languageStyles}  options={options} defaultValue={options[defaultValueIndex]}  onChange={(option: any) => {changeLanguage(option.value)}}
                formatOptionLabel={(option : any, { context }) => {
                    return context === 'menu' ? option.label : option.input;
                }}
                isSearchable={false}
        />
    </div>)
}

export const LanguageSelector = dynamic(() => Promise.resolve(_LanguageSelector), {
    ssr: false
});
